module.exports = {"id":"192560","name":"Reinhold Yabo","rating":"74","photo":"./data/images/photos/4/192560.png","club":{"name":"RB Salzbourg","logo":"./data/images/clubs/RBSalzbourg.png"},"positions":["MC","MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ReinholdYabo0.json
// module id = 3561
// module chunks = 0